import angular from 'angular';

export const angularSetValueNotInsured = (value: string | null) => {
  const service: {
    setValueNotInsured: (value: string | null) => void;
  } = angular.element(document.body).injector().get('CheckoutService');
  service?.setValueNotInsured(value);
};
